import { render, staticRenderFns } from "./TIYXAHAY.vue?vue&type=template&id=61af6371&scoped=true&"
import script from "./TIYXAHAY.vue?vue&type=script&lang=js&"
export * from "./TIYXAHAY.vue?vue&type=script&lang=js&"
import style0 from "./TIYXAHAY.vue?vue&type=style&index=0&id=61af6371&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af6371",
  null
  
)

export default component.exports